import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ZeekerWidget from "../ads/zeekerwidget";
import InfolinksAd from "../ads/infoLinksAd";

const PageAds = ({ containerRef }) => {
  const location = useLocation();

// const ENABLE_ZEEKER = !location.pathname.includes("/content/");
const ENABLE_ZEEKER = false;
  const ENABLE_INFOLINKS = false;
  // const ENABLE_GOOGLE_ADS = false;

  /* ---------------- LOAD ADSENSE SCRIPT (ONCE) ---------------- */
  // useEffect(() => {
  //   if (!ENABLE_GOOGLE_ADS) return;

  //   const existingScript = document.querySelector(
  //     'script[src*="adsbygoogle.js"]'
  //   );

  //   if (!existingScript) {
  //     const script = document.createElement("script");
  //     script.src =
  //       "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2751262109036390";
  //     script.async = true;
  //     script.crossOrigin = "anonymous";
  //     document.head.appendChild(script);
  //   }
  // }, [ENABLE_GOOGLE_ADS]);

    useEffect(() => {

    let cancelled = false;

    const initializeAds = async () => {

      try {

        /*
         * Wait until AdSenseLoader has finished
         * loading the Google AdSense library.
         */
        if (
          window.__TELUGUONE_ADSENSE_PROMISE__
        ) {

          await window.__TELUGUONE_ADSENSE_PROMISE__;

        }

        if (cancelled) {
          return;
        }

        /*
         * Make sure Google AdSense is available.
         */
        window.adsbygoogle =
          window.adsbygoogle || [];

        console.log(
          "AdSense: Initializing page:",
          location.pathname
        );

        /*
         * Initialize the ad units
         * belonging to this React route.
         */
        window.adsbygoogle.push({});

        console.log(
          "AdSense: Push completed:",
          location.pathname
        );

      } catch (error) {

        console.error(
          "AdSense page initialization failed:",
          location.pathname,
          error
        );

      }

    };

    initializeAds();

    return () => {
      cancelled = true;
    };

  }, [location.pathname]);

  /* ---------------- HANDLE ROUTE CHANGE (SPA FIX) ---------------- */
  useEffect(() => {
    
    // if (window.adsbygoogle) {
    //   try {
    //     window.adsbygoogle.push({});
    //   } catch (e) {
        
    //   }
    // }

    // Wait until AdSense library is available
    // if (!window.adsbygoogle) {
    //   return;
    // }

    // try {

    //   window.adsbygoogle.push({});

    // } catch (error) {

    //   console.error("AdSense page initialization error:", error);

    // }

  
    if (window.Infolinks && typeof window.Infolinks.reInit === "function") {
      window.Infolinks.reInit();
    }


  }, [location.pathname]);

  return (
    <div key={location.pathname}>
    
      {ENABLE_INFOLINKS && <InfolinksAd />}

   
      {ENABLE_ZEEKER && (
        <ZeekerWidget containerRef={containerRef} />
      )}
    </div>
  );
};

export default PageAds;